/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationTrendWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostOptimizationTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostOptimizationTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationTrendWidgetConfiguration>): CostOptimizationTrendWidgetConfiguration {
        let obj = Object.assign(new CostOptimizationTrendWidgetConfiguration(), model);
        CostOptimizationTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationTrendWidgetConfiguration>): CostOptimizationTrendWidgetConfiguration {
        if (!model) return null;
        return CostOptimizationTrendWidgetConfiguration.newInstance(<CostOptimizationTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationTrendWidgetConfiguration) {
        if (!obj) return;

        models.CostOptimizationTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationTrendWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostOptimizationTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
